module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_100-218093e0e95ab9e9661d86220d12bca6.png";